export interface Course {
  path: string;
  bgColor: string;
  bgImage: string;
  title: string;
  color: string;
  sc?: boolean;
}

export const corsi: Course[] = [
  {
    path: 'scratch',
    bgColor: '#FDE3E4',
    bgImage: "url('assets/img/backgrounds/bg_scratch.svg')",
    title: 'Scratch',
    color: '#03288E',
  },
  {
    path: 'app-inventor',
    bgColor: '#03288E',
    bgImage: "url('assets/img/backgrounds/bg_inventor.svg')",
    title: 'App Inventor',
    color: '#FFFFFF',
  },
  {
    path: 'digital-storytelling',
    bgColor: '#F3BA03',
    bgImage: "url('assets/img/backgrounds/bg_storytelling.svg')",
    title: 'Digital Storytelling',
    color: '#03288E',
  },
  {
    path: 'html-css',
    bgColor: '#242424',
    bgImage: "url('assets/img/backgrounds/bg_htmlcss.svg')",
    title: 'HTML e CSS',
    color: '#FFFFFF',
  },
  {
    path: 'ux-ui',
    bgColor: '#D7AAFF',
    bgImage: "url('assets/img/backgrounds/bg_uxui.svg')",
    title: 'UX/UI Design',
    color: '#FFFFFF',
  },
  {
    path: 'programmazione-droni',
    bgColor: '#D4D4D4',
    bgImage: "url('assets/img/backgrounds/bg_droni.svg')",
    title: 'Programmazione Droni',
    color: '#03288E',
  },
  {
    path: 'social-media',
    bgColor: '#FC9F90',
    bgImage: "url('assets/img/backgrounds/bg_socialMedia.svg')",
    title: 'Educazione ai Social Media',
    color: '#FFFFFF',
    sc: true,
  },
  {
    path: 'stampa-3d',
    bgColor: '#A482ED',
    bgImage: "url('assets/img/backgrounds/bg_stampa3d.svg')",
    title: 'Stampa 3D',
    color: '#FFFFFF',
  },
  {
    path: 'arduino',
    bgColor: '#A1EC83',
    bgImage: "url('assets/img/backgrounds/bg_scratch.svg')",
    title: 'Arduino',
    color: '#03288E',
  },
  {
    path: 'robotica-educativa',
    bgColor: '#B1CEBA',
    bgImage: "url('assets/img/backgrounds/bg_robotica.svg')",
    title: 'Robotica Educativa',
    color: '#03288E',
  },
  {
    path: 'minecraft',
    bgColor: '#82CDED',
    bgImage: "url('assets/img/backgrounds/bg_minecraft.svg')",
    title: 'Minecraft',
    color: '#FFFFFF',
  },
  {
    path: 'unplugged',
    bgColor: '#ffffff',
    bgImage: "url('assets/img/backgrounds/bg_scratch.svg')",
    title: 'Programmazione Unplugged',
    color: '#03288E',
    sc: true,
  },
];

export const coursesList: any = [
  {
    name: 'Scratch',
    tag: 'T/E/M',
    img: 'assets/img/corsi/scratch.png',
    text: 'Crea cartoni animati, animazioni e storie interattive, quiz e puzzle, ma anche dei semplici giochi arcade.',
    url: '/scratch',
  },
  {
    name: 'Minecraft',
    tag: 'T/E/M',
    img: 'assets/img/corsi/minecraft.png',
    text: 'è un gioco di costruzione ed esplorazione dove si può interagire con il mondo di gioco posizionando e rompendo vari tipi di blocchi in un ambiente tridimensionale. Offre la possibilità di muoversi liberamente all’interno del mondo virtuale, dando la libertà di porre delle finalità proprie, di interagire con l’ambiente e ciò che lo popola.',
    url: '/minecraft',
  },
  {
    name: 'HTML e CSS',
    tag: 'T/S',
    img: 'assets/img/corsi/html.png',
    text: 'Cosa sono e come sono fatte le pagine web? Creazione di un sito composto da alcune pagine web.',
    url: '/html-css',
  },
  {
    name: 'Educazione ai Social Media',
    tag: 'T/M/S',
    img: 'assets/img/corsi/socialMedia.png',
    text: 'Utilizzo dei social e della comunicazione digitale, esaltandone i lati positivi e le conseguenze di un uso inconsapevole.',
    url: '/social-media',
  },
  {
    name: 'Programmazione Unplugged',
    tag: 'T/E/M',
    img: 'assets/img/corsi/unplugged.png',
    text: 'Un percorso di apprendimento dei principi della programmazione senza l’utilizzo del computer.',
    url: '/unplugged',
  },
  {
    name: 'App Inventor',
    tag: 'T/E/M',
    img: 'assets/img/corsi/appInventor.png',
    text: 'E’ uno strumento per realizzare applicazioni Android. La sua interfaccia consente di programmare senza scrivere codice.',
    url: '/app-inventor',
  },
  {
    name: 'Robotica Educativa',
    tag: 'T/E/M',
    img: 'assets/img/corsi/robotica.png',
    text: 'Per imparare tramite la programmazione e lo sviluppo di un robot, le materie scientifiche alla base della programmazione.',
    url: '/robotica-educativa',
  },
  {
    name: 'Digital Storytelling',
    tag: 'T/E/M',
    img: 'assets/img/corsi/storytelling.png',
    text: 'Creare storie e raccontarle tramite l’uso di tecnologie digitali con benefici didattici, cognitivi, relazionali e motivazionali.',
    url: '/digital-storytelling',
  },
  {
    name: 'UX/UI Design',
    tag: 'T/S',
    img: 'assets/img/corsi/design.png',
    text: 'Imparare la grafica web, il metodo del design, la User Experience (UX) e la User Interface (UI).',
    url: '/ux-ui',
  },
  {
    name: 'Arduino',
    tag: 'T/M/S',
    img: 'assets/img/corsi/arduino.png',
    text: 'Crea il tuo circuito, programmalo e testalo grazie al software di simulazione di Tinkercad Circuits.',
    url: '/arduino',
  },
  {
    name: 'Stampa 3D',
    tag: 'T/M/S',
    img: 'assets/img/corsi/stampa3d.png',
    text: 'Divertiti a dare una forma concreta alle tue idee con il software TinkerCAD.',
    url: '/stampa-3d',
  },
  {
    name: 'Programmazione Droni',
    tag: 'T/M/S',
    img: 'assets/img/corsi/programmazione-droni.png',
    text: 'Impara a programmare il tuo drone Tello EDU, piccolo e compatto ma con molte funzionalità.',
    url: '/programmazione-droni',
  },
];
